import { render, staticRenderFns } from "./common-header.vue?vue&type=template&id=b7d22886&"
import script from "./common-header.vue?vue&type=script&lang=ts&"
export * from "./common-header.vue?vue&type=script&lang=ts&"
import style0 from "./common-header.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports